import { buildHeroSlides } from '../../utils/heroSlides';
import HeroSlider from './HeroSlider';
import './HeroSection.css';

/**
 * The hero slot, plus the trust strip that always sits beneath it.
 *
 * Campaigns placed at 'hero' and the hand-picked hero products share one
 * slider; the single hero_banners slide covers a store that has published
 * neither.
 */
const HeroSection = ({ banner, campaigns = [], heroProducts = [] }) => {
  const slides = buildHeroSlides({ campaigns, heroProducts, banner });

  return (
    <section className="hero-section">
      <HeroSlider slides={slides} />

      {/* Feature Strip */}
      <div className="hero-feature-strip">
        <div className="hero-feature-item">
          <span className="hero-feature-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2L4 5.5V11C4 15.418 7.582 19.472 12 21C16.418 19.472 20 15.418 20 11V5.5L12 2Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinejoin="round"
              />
              <path
                d="M9 12L11 14L15 10"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="hero-feature-label">1 Year Warranty</span>
        </div>

        <div className="hero-feature-divider" />

        <div className="hero-feature-item">
          <span className="hero-feature-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 14H17M3 14V8C3 6.895 3.895 6 5 6H15C16.105 6 17 6.895 17 8V14M3 14H2M17 14H22L19 10H17M17 14V11H19"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle
                cx="7"
                cy="16.5"
                r="1.5"
                stroke="currentColor"
                strokeWidth="1.4"
              />
              <circle
                cx="18"
                cy="16.5"
                r="1.5"
                stroke="currentColor"
                strokeWidth="1.4"
              />
            </svg>
          </span>
          <span className="hero-feature-label">Delivery All Over Nepal</span>
        </div>

        <div className="hero-feature-divider" />

        <div className="hero-feature-item">
          <span className="hero-feature-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2"
                y="6"
                width="20"
                height="13"
                rx="2"
                stroke="currentColor"
                strokeWidth="1.6"
              />
              <path
                d="M2 10H22"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
              <circle cx="12" cy="14.5" r="1.5" fill="currentColor" />
            </svg>
          </span>
          <span className="hero-feature-label">Cash on Delivery</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
